export const useKakaoPixel = () => {
  const config = useRuntimeConfig()

  if (config.public.env !== 'prod') {
    return {
      kakaoPixelPageView: () => {},
      kakaoPixelCompleteRegistration: () => {},
      kakaoPixelViewContent: () => {},
      kakaoPixelPurchase: () => {}
    }
  }

  const kakaoPixelPageView = (tag: string) => {
    try {
      window.kakaoPixel(config.public.kakaoPixelId)?.pageView(tag)
    } catch (error) {
      console.warn(error)
    }
  }

  const kakaoPixelCompleteRegistration = () => {
    try {
      window.kakaoPixel(config.public.kakaoPixelId)?.completeRegistration()
    } catch (error) {
      console.warn(error)
    }
  }

  const kakaoPixelViewContent = (id:string, tag:string) => {
    /**
     * ! id: planId !
     * ! tag: 'normal' | 'gift' | 'charge' !
     *
     */
    try {
      window.kakaoPixel(config.public.kakaoPixelId)?.viewContent({ id, tag })
    } catch (error) {
      console.warn(error)
    }
  }

  const kakaoPixelPurchase = (amount: number) => {
    try {
      window.kakaoPixel(config.public.kakaoPixelId)?.purchase({
        total_price: String(amount)
      })
    } catch (error) {
      console.warn(error)
    }
  }

  return {
    kakaoPixelPageView,
    kakaoPixelCompleteRegistration,
    kakaoPixelViewContent,
    kakaoPixelPurchase
  }
}
